import { LayerDefinition } from './types';

export const dustDefinition: LayerDefinition = {
  id: 'dust',
  name: 'Global Dust',
  category: 'environment',
  categoryLabel: 'Environmental & Air Quality',
  icon: '🏜️',
  description: 'Global desert dust PM2.5/PM10 aerosol dispersion and surface concentration forecast from NOAA GEFS Aerosols.',
  sourceModels: ['gefs_dust (Global 0.25° GEFS-Aerosols)'],
  outputModels: ['Global dust PM2.5 concentration .pmtiles'],
  config: {
    levels: ['surface'],
    defaultModel: 'gefs_dust'
  }
};

export default dustDefinition;
